import { useCallback, useEffect, useState } from 'react';
import { AchGuideVariant, markGuideShownThisSession, shouldAutoOpenGuide } from './achGuideStorage';

/**
 * Open/close state of an ACH connection guide, plus its first-visit behavior: while `autoOpenWhen` is true the guide
 * opens by itself once per page load. `show` reopens it any time.
 */
export const useAchConnectionGuide = (variant: AchGuideVariant, autoOpenWhen: boolean) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (autoOpenWhen && shouldAutoOpenGuide(variant)) {
      markGuideShownThisSession(variant);
      setOpen(true);
    }
  }, [autoOpenWhen, variant]);

  const show = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);

  return { open, show, close };
};
